import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaEye, FaEdit } from 'react-icons/fa'; // Importing icons
import penEdit from '../../../Assets/images/pen-squareEdit.png';
import eye from '../../../Assets/images/eye.png';
import { useNavigate } from 'react-router-dom';
import LoanDetailsModal from './LoanDetailsModal';
import ChildTable from './ChildTable';
import FirstRefinanceChildTable from './FirstRefinanceChildTable';
import SecondRefinanceChildTable from './SecondRefinanceChildTable';
import { API_BASE_URL } from '../../../config';
console.clear();
const GridMLR = () => {
  const [data, setData] = useState([]);
  const [firstRefinanceData, setFirstRefinanceData] = useState([]);
  const [secondRefinanceData, setSecondRefinanceData] = useState([]);
  const [error, setError] = useState(null);
 
  const [expandedRows, setExpandedRows] = useState({});
  const [activeTab, setActiveTab] = useState('UPAS');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const navigate = useNavigate(); // Add this for navigation

  // Function to handle viewing loan details
  const handleViewYourLoan = loan => {
    setSelectedLoan(loan);
    setIsModalOpen(true);
  };

  const handleNewApplication = () => {
    navigate('/NewLoanApplication');
  };

  // upas loan list
  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const response = await axios.get(
          // 'https://finwise-backend.vercel.app/account/user-loan-list/',
          // 'https://finwiseback.finwise.com.bd/account/user-loan-list/',
          `${API_BASE_URL}/account/user-loan-list/`,
          {
            headers: {
              Cookie:
                'csrftoken=lgcs2QC0IaxcCeeVoYEOw9IlT5Dvo0r9; sessionid=bxyh6gm0sh7o08bms9h3eqgu6gt80weo',
            },
            withCredentials: true,
          }
        );
        console.log("upas data",response.data);
        setData(response.data);
      } catch (err) {
        console.error('Error fetching loan data:', err);
        setError(err.message);
      }
    };

    fetchLoanData();
  }, []);
  // first refinance loan list
  useEffect(() => {
    const fetchFirstRefinanceLoanData = async () => {
      try {
        const response = await axios.get(
          // 'https://finwise-backend.vercel.app/account/user-loan-list/',
          // 'https://finwiseback.finwise.com.bd/account/user-loan-list/',
          `${API_BASE_URL}/account/user-first-refinance-loan/`,
          {
            headers: {
              Cookie:
                'csrftoken=aNDEX8Hh9fBH9lwYAuuu2NoVREw0SYio; sessionid=b8tgjifnsbbwc1bpxwsqgqf1hnswfsml',
            },
            withCredentials: true,
          }
        );
        console.log("firstrefinancedat:",response.data);
        setFirstRefinanceData(response.data);
      } catch (err) {
        console.error('Error fetching loan data:', err);
        setError(err.message);
      }
    };

    fetchFirstRefinanceLoanData();
  }, []);
  // Second refinance loan list
  useEffect(() => {
    const fetchSecondRefinanceLoanData = async () => {
      try {
        const response = await axios.get(
          // 'https://finwise-backend.vercel.app/account/user-loan-list/',
          // 'https://finwiseback.finwise.com.bd/account/user-loan-list/',
          `${API_BASE_URL}/account/user-second-refinance-loan/`,
          {
            headers: {
              Cookie:
                'csrftoken=aNDEX8Hh9fBH9lwYAuuu2NoVREw0SYio; sessionid=b8tgjifnsbbwc1bpxwsqgqf1hnswfsml',
            },
            withCredentials: true,
          }
        );
        console.log("second trefinance data:",response.data);
        setSecondRefinanceData(response.data);
      } catch (err) {
        console.error('Error fetching loan data:', err);
        setError(err.message);
      }
    };

    fetchSecondRefinanceLoanData();
  }, []);

  const handleRowToggle = id => {
    setExpandedRows(prevState => ({
      ...prevState,
      [id]: !prevState[id], // Toggle the expanded state for the row
    }));
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Function to navigate to edit page
  const handleEdit = id => {
    navigate(`/edit-loan/${id}`);
    // console.log(id);
  };
  // Function to navigate to edit page
  const handleFirstRefinanceEdit = id => {
    navigate(`/edit-firstRefinane/${id}`);
    // console.log(id);
  };
  // Function to navigate to edit page
  const handleSecondRefinanceEdit = id => {
    navigate(`/edit-secondRefinane/${id}`);
    // console.log(id);
  };
  //  const [offered, setOffered] = useState(null);
  //  const [cancelled, setCancelled] = useState(null);
  // const handleDataFromChild = data => {
  //   console.log('Data received from child:', data.cancelled);
  //   setOffered(data.offered);
  //   setCancelled(data.cancelled);
  // };

  return (
    <div className="w-full p-4 bg-white rounded-lg shadow-2xl border">
      <h2 className="text-lg md:text-xl font-bold mb-4 text-gray-700 py-2 rounded-md text-center">
        My UPAS/LC Requests
      </h2>
      <LoanDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        loanDetails={selectedLoan}
      />

      {/* tab buttons */}
      <div className="flex space-x-0 mb-2 lg:text-lg 2xl:text-lg text-xs">
        <button
          className={`px-4 py-2 rounded-tl-md border-r border-gray-300 ${
            activeTab === 'UPAS' ? 'bg-headerBtn text-white' : 'bg-gray-100'
          }`}
          onClick={() => setActiveTab('UPAS')}
        >
          UPAS
        </button>
        <button
          className={`px-4 py-2 border-r border-gray-300 ${
            activeTab === 'FirstRefinance'
              ? 'bg-headerBtn text-white'
              : 'bg-gray-100'
          }`}
          onClick={() => setActiveTab('FirstRefinance')}
        >
          First Refinance
        </button>
        <button
          className={`px-4 py-2 rounded-tr-md ${
            activeTab === 'SecondRefinance'
              ? 'bg-headerBtn text-white'
              : 'bg-gray-100'
          }`}
          onClick={() => setActiveTab('SecondRefinance')}
        >
          Second Refinance
        </button>
      </div>
      {/* tab content */}
      {activeTab === 'UPAS' && (
        <div>
          {/* Table Code */}
          <div className="overflow-x-auto w-full text-xs md:text-sm">
            <div className="overflow-y-auto max-h-[420px]">
              <table className="w-full bg-white rounded-lg">
                <thead className="bg-headerBtn text-white sticky top-0 z-0">
                  <tr>
                    <th className="py-2 px-4 rounded-tl-lg">S/N</th>
                    <th className="py-2 px-4">Offered</th>
                    <th className="py-2 px-4">Cancelled</th>
                    <th className="py-2 px-4">LC Applicant</th>
                    {/* <th className="py-2 px-4">Amount</th> */}
                    <th className="py-2 px-4">LC Value</th>
                    <th className="py-2 px-4">Issue Bank</th>
                    <th className="py-2 px-4">Document</th>
                    {/* <th className="py-2 px-4">Beneficiary Bank</th> */}
                    <th className="py-2 px-4">LC Maturity</th>
                    {/* <th className="py-2 px-4">If Refinance</th> */}
                    {/* <th className="py-2 px-4">Tenor Required</th> */}
                    {/* <th className="py-2 px-4">Status</th> */}
                    <th className="py-2 px-4 rounded-tr-lg">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((row, index) => (
                      <React.Fragment key={row.id}>
                        <tr
                          className="bg-AboutUsBg text-center cursor-pointer"
                          onClick={() => handleRowToggle(row.id)} // Toggle row on click
                        >
                          <td className="py-2 px-4 rounded-tl-lg">
                            {index + 1}
                          </td>
                          <td className="py-2 px-4">{row.approved_count}</td>
                          <td className="py-2 px-4">{row.canceled_count}</td>
                          <td className="py-2 px-4">{row.lc_applicant}</td>
                          {/* <td className="py-2 px-4">{row.amount}</td> */}
                          <td className="py-2 px-4">{row.lc_value}</td>
                          <td className="py-2 px-4">{row.issue_bank}</td>
                          {/* <td className="py-2 px-4">{row.document}</td> */}
                          <td className="py-2 px-4">
                            {row.document ? (
                              <a
                                href={row.document}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                              >
                                View Document
                              </a>
                            ) : (
                              'No document'
                            )}
                          </td>
                          {/* <td className="py-2 px-4">{row.beneficiary_bank}</td> */}
                          {/* <td className="py-2 px-4">{row.lc_currency}</td> */}
                          {/* <td className="py-2 px-4">{row.lc_maturity}</td> */}
                          <td className="py-2 px-4">
                            {(() => {
                              const date = new Date(row.lc_maturity);
                              const day = String(date.getDate()).padStart(
                                2,
                                '0'
                              );
                              const month = String(
                                date.getMonth() + 1
                              ).padStart(2, '0'); // Months are zero-based, so +1
                              const year = date.getFullYear();
                              return `${day}-${month}-${year}`;
                            })()}
                          </td>

                          {/* <td className="py-2 px-4">
                        {row.refinance ? 'Yes' : 'No'}
                      </td> */}
                          {/* <td className="py-2 px-4">
                            {row.tenor_required} months
                          </td> */}

                          {/* <td className="py-2 px-4">
                            <button
                              className={`px-3 py-1 rounded-md md:w-28 w-20 ${
                                row.status === 'offered'
                                  ? 'bg-green-500 text-white'
                                  : row.status === 'pending'
                                  ? 'bg-yellow-500 text-white'
                                  : row.status === 'cancel'
                                  ? 'bg-red-500 text-white'
                                  : 'bg-gray-500 text-white'
                              }`}
                            >
                              {row.status === 'offered'
                                ? 'Offered'
                                : row.status === 'pending'
                                ? 'Pending'
                                : row.status === 'cancel'
                                ? 'Cancelled'
                                : 'Null'}
                            </button>
                          </td> */}

                          {/* <td className="py-2 px-4 flex justify-center space-x-4 rounded-bl-lg">
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            handleViewYourLoan(row.id);
                          }}
                          className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
                          aria-label="View"
                        >
                          <img src={eye} alt="View" />
                        </button>
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            handleEdit(row.id);
                          }}
                          className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
                          aria-label="Edit"
                        >
                          <img src={penEdit} alt="Edit" />
                        </button>
                      </td> */}
                          {/* Your table data cells */}
                          <td className="py-2 px-4 flex justify-center space-x-4 rounded-bl-lg lg:mt-0 mt-2">
                            <button
                              onClick={e => {
                                e.stopPropagation();
                                handleViewYourLoan(row);
                              }}
                              className="text-gray-600 hover:text-btnHover transition-colors text-2xl "
                              aria-label="View"
                            >
                              <img src={eye} alt="View" />
                            </button>
                            <button
                              onClick={e => {
                                e.stopPropagation();
                                handleEdit(row.id);
                              }}
                              className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
                              aria-label="Edit"
                            >
                              <img src={penEdit} alt="Edit" />
                            </button>
                          </td>
                        </tr>
                        {expandedRows[row.id] && (
                          <ChildTable
                            loan_ID={row.id}
                            // onDataReceived={handleDataFromChild}
                          />
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        <div className="flex items-center justify-center gap-2">
                          <p>
                            You don't have any UPAS/LC applicaton available.{' '}
                          </p>
                          <button
                            onClick={handleNewApplication}
                            className="underline hover:text-btnHover text-headerBtn"
                          >
                            {' '}
                            Click for UPAS/LC new applicaton
                          </button>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'FirstRefinance' && (
        <div>
          {/* Table Code */}
          <div className="overflow-x-auto w-full text-xs md:text-sm">
            <div className="overflow-y-auto max-h-[420px]">
              <table className="w-full bg-white rounded-lg">
                <thead className="bg-headerBtn text-white sticky top-0 z-0">
                  <tr>
                    <th className="py-2 px-4 rounded-tl-lg">S/N</th>
                    <th className="py-2 px-4">Offered</th>
                    <th className="py-2 px-4">Cancelled</th>
                    <th className="py-2 px-4">UPAS Bank Name</th>
                    {/* <th className="py-2 px-4">LC Value</th> */}
                    <th className="py-2 px-4">UPAS Maturity Date</th>
                    <th className="py-2 px-4">PI Copy</th>
                    <th className="py-2 px-4">LC Copy</th>
                    <th className="py-2 px-4">Acceptance Copy</th>
                    {/* <th className="py-2 px-4">Status</th> */}
                    <th className="py-2 px-4 rounded-tr-lg">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {firstRefinanceData.length > 0 ? (
                    firstRefinanceData.map((row, index) => (
                      <React.Fragment key={row.id}>
                        <tr
                          className="bg-AboutUsBg text-center cursor-pointer"
                          onClick={() => handleRowToggle(row.id)} // Toggle row on click
                        >
                          <td className="py-2 px-4 rounded-tl-lg">
                            {index + 1}
                          </td>
                          <td className="py-2 px-4">{row.approved_count}</td>
                          <td className="py-2 px-4">{row.canceled_count}</td>
                          <td className="py-2 px-4">{row.UPAS_bank_name}</td>
                          {/* <td className="py-2 px-4">{row.lc_value}%</td> */}
                          {/* <td className="py-2 px-4">{row.lc_currency}</td> */}
                          <td className="py-2 px-4">
                            {(() => {
                              const date = new Date(row.UPAS_maturity_date);
                              const day = String(date.getDate()).padStart(
                                2,
                                '0'
                              );
                              const month = String(
                                date.getMonth() + 1
                              ).padStart(2, '0'); // Months are zero-based, so +1
                              const year = date.getFullYear();
                              return `${day}-${month}-${year}`;
                            })()}
                          </td>
                          <td className="py-2 px-4">
                            {row.PI_document ? (
                              <a
                                // href={row.PI_document}
                                href={`${API_BASE_URL}${row.PI_document}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                              >
                                View Document
                              </a>
                            ) : (
                              'No document'
                            )}
                          </td>

                          <td className="py-2 px-4">
                            {row.LC_document ? (
                              <a
                                // href={row.LC_document}
                                href={`${API_BASE_URL}${row.LC_document}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                              >
                                View Document
                              </a>
                            ) : (
                              'No document'
                            )}
                          </td>

                          <td className="py-2 px-4">
                            {row.Acceptance_copy ? (
                              <a
                                // href={row.Acceptance_copy}
                                href={`${API_BASE_URL}${row.Acceptance_copy}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                              >
                                View Document
                              </a>
                            ) : (
                              'No document'
                            )}
                          </td>

                          {/* <td className="py-2 px-4">
                            <button
                              className={`px-3 py-1 rounded-md md:w-28 w-20 ${
                                row.status === 'offered'
                                  ? 'bg-green-500 text-white'
                                  : row.status === 'pending'
                                  ? 'bg-yellow-500 text-white'
                                  : row.status === 'cancel'
                                  ? 'bg-red-500 text-white'
                                  : 'bg-gray-500 text-white'
                              }`}
                            >
                              {row.status === 'offered'
                                ? 'Offered'
                                : row.status === 'pending'
                                ? 'Pending'
                                : row.status === 'cancel'
                                ? 'Cancelled'
                                : 'Null'}
                            </button>
                          </td> */}
                          {/* Your table data cells */}
                          <td className="py-2 px-4 flex justify-center space-x-4 rounded-bl-lg lg:mt-0 mt-2">
                            {/* <button
                              onClick={e => {
                                e.stopPropagation();
                                handleViewYourLoan(row);
                              }}
                              className="text-gray-600 hover:text-btnHover transition-colors text-2xl "
                              aria-label="View"
                            >
                              <img src={eye} alt="View" />
                            </button> */}
                            <button
                              onClick={e => {
                                e.stopPropagation();
                                handleFirstRefinanceEdit(row.id);
                              }}
                              className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
                              aria-label="Edit"
                            >
                              <img src={penEdit} alt="Edit" />
                            </button>
                          </td>
                        </tr>
                        {expandedRows[row.id] && (
                          <FirstRefinanceChildTable fr_loan_ID={row.id} />
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        <div className="flex items-center justify-center gap-2">
                          <p>
                            You don't have any UPAS/LC applicaton available.{' '}
                          </p>
                          <button
                            onClick={handleNewApplication}
                            className="underline hover:text-btnHover text-headerBtn"
                          >
                            {' '}
                            Click for First Refinance new applicaton
                          </button>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'SecondRefinance' && (
        <div>
          {/* Table Code */}
          <div className="overflow-x-auto w-full text-xs md:text-sm xl:text-sm">
            <div className="overflow-y-auto max-h-[420px]">
              <table className="w-full bg-white rounded-lg">
                <thead className="bg-headerBtn text-white sticky top-0 z-0">
                  <tr>
                    <th className="py-2 px-4 rounded-tl-lg">S/N</th>
                    <th className="py-2 px-4">Offered</th>
                    <th className="py-2 px-4">Cancelled</th>
                    <th className="py-2 px-4">UPAS Bank Name</th>
                    <th className="py-2 px-4">UPAS Maturity Date</th>
                    {/* <th className="py-2 px-4">Bank Name</th>
                    <th className="py-2 px-4">Maturity Date</th> */}
                    <th className="py-2 px-4">PI Copy</th>
                    <th className="py-2 px-4">LC Copy</th>
                    <th className="py-2 px-4">Acceptance Copy</th>
                    {/* <th className="py-2 px-4">Status</th> */}
                    <th className="py-2 px-4 rounded-tr-lg">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {secondRefinanceData.length > 0 ? (
                    secondRefinanceData.map((row, index) => (
                      <React.Fragment key={row.id}>
                        <tr
                          className="bg-AboutUsBg text-center cursor-pointer"
                          onClick={() => handleRowToggle(row.id)} // Toggle row on click
                        >
                          <td className="py-2 px-4 rounded-tl-lg">
                            {index + 1}
                          </td>
                          <td className="py-2 px-4">{row.offered_count}</td>
                          <td className="py-2 px-4">{row.canceled_count}</td>
                          <td className="py-2 px-4">{row.UPAS_bank_name}</td>
                          <td className="py-2 px-4">
                            {(() => {
                              const date = new Date(row.UPAS_maturity_date);
                              const day = String(date.getDate()).padStart(
                                2,
                                '0'
                              );
                              const month = String(
                                date.getMonth() + 1
                              ).padStart(2, '0'); // Months are zero-based, so +1
                              const year = date.getFullYear();
                              return `${day}-${month}-${year}`;
                            })()}
                          </td>
                          {/* <td className="py-2 px-4">{row.bank_name}</td>
                          <td className="py-2 px-4">
                            {(() => {
                              const date = new Date(row.maturity_date);
                              const day = String(date.getDate()).padStart(
                                2,
                                '0'
                              );
                              const month = String(
                                date.getMonth() + 1
                              ).padStart(2, '0'); // Months are zero-based, so +1
                              const year = date.getFullYear();
                              return `${day}-${month}-${year}`;
                            })()}
                          </td> */}

                          <td className="py-2 px-4">
                            {row.PI_document ? (
                              <a
                                // href={row.PI_document}
                                href={`${API_BASE_URL}${row.PI_document}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                              >
                                View Document
                              </a>
                            ) : (
                              'No document'
                            )}
                          </td>

                          <td className="py-2 px-4">
                            {row.LC_document ? (
                              <a
                                // href={row.LC_document}
                                href={`${API_BASE_URL}${row.LC_document}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                              >
                                View Document
                              </a>
                            ) : (
                              'No document'
                            )}
                          </td>

                          <td className="py-2 px-4">
                            {row.Acceptance_copy ? (
                              <a
                                // href={row.Acceptance_copy}
                                href={`${API_BASE_URL}${row.Acceptance_copy}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                              >
                                View Document
                              </a>
                            ) : (
                              'No document'
                            )}
                          </td>

                          {/* <td className="py-2 px-4">
                            <button
                              className={`px-3 py-1 rounded-md md:w-28 w-20 ${
                                row.status === 'offered'
                                  ? 'bg-green-500 text-white'
                                  : row.status === 'pending'
                                  ? 'bg-yellow-500 text-white'
                                  : row.status === 'cancel'
                                  ? 'bg-red-500 text-white'
                                  : 'bg-gray-500 text-white'
                              }`}
                            >
                              {row.status === 'offered'
                                ? 'Offered'
                                : row.status === 'pending'
                                ? 'Pending'
                                : row.status === 'cancel'
                                ? 'Cancelled'
                                : 'Null'}
                            </button>
                          </td> */}

                          {/* <td className="py-2 px-4 flex justify-center space-x-4 rounded-bl-lg">
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            handleViewYourLoan(row.id);
                          }}
                          className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
                          aria-label="View"
                        >
                          <img src={eye} alt="View" />
                        </button>
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            handleEdit(row.id);
                          }}
                          className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
                          aria-label="Edit"
                        >
                          <img src={penEdit} alt="Edit" />
                        </button>
                      </td> */}
                          {/* Your table data cells */}
                          <td className="py-2 px-4 flex justify-center space-x-4 rounded-bl-lg lg:mt-0 mt-2">
                            {/* <button
                              onClick={e => {
                                e.stopPropagation();
                                handleViewYourLoan(row);
                              }}
                              className="text-gray-600 hover:text-btnHover transition-colors text-2xl "
                              aria-label="View"
                            >
                              <img src={eye} alt="View" />
                            </button> */}
                            <button
                              onClick={e => {
                                e.stopPropagation();
                                handleSecondRefinanceEdit(row.id);
                              }}
                              className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
                              aria-label="Edit"
                            >
                              <img src={penEdit} alt="Edit" />
                            </button>
                          </td>
                        </tr>
                        {expandedRows[row.id] && (
                          <SecondRefinanceChildTable sr_loan_ID={row.id} />
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        <div className="flex items-center justify-center gap-2">
                          <p>
                            You don't have any UPAS/LC applicaton available.{' '}
                          </p>
                          <button
                            onClick={handleNewApplication}
                            className="underline hover:text-btnHover text-headerBtn"
                          >
                            {' '}
                            Click for Second Refinance new applicaton
                          </button>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GridMLR;

// {/* Table Code */}
// <div className="overflow-x-auto w-full text-xs md:text-lg">
//   <div className="overflow-y-auto max-h-[420px]">
//     <table className="w-full bg-white rounded-lg">
//       <thead className="bg-headerBtn text-white sticky top-0 z-0">
//         <tr>
//           <th className="py-2 px-4 rounded-tl-lg">S/N</th>
//           <th className="py-2 px-4">LC Applicant</th>
//           <th className="py-2 px-4">Amount</th>
//           <th className="py-2 px-4">LC Value</th>
//           <th className="py-2 px-4">LC Maturity</th>
//           {/* <th className="py-2 px-4">If Refinance</th> */}
//           <th className="py-2 px-4">Tenor Required</th>
//           <th className="py-2 px-4">Status</th>
//           <th className="py-2 px-4 rounded-tr-lg">Action</th>
//         </tr>
//       </thead>
//       <tbody>
//         {data.length > 0 ? (
//           data.map((row, index) => (
//             <React.Fragment key={row.id}>
//               <tr
//                 className="bg-AboutUsBg text-center cursor-pointer"
//                 onClick={() => handleRowToggle(row.id)} // Toggle row on click
//               >
//                 <td className="py-2 px-4 rounded-tl-lg">{index + 1}</td>
//                 <td className="py-2 px-4">{row.lc_applicant}</td>
//                 <td className="py-2 px-4">{row.amount}</td>
//                 <td className="py-2 px-4">{row.lc_value}%</td>
//                 {/* <td className="py-2 px-4">{row.lc_currency}</td> */}
//                 {/* <td className="py-2 px-4">{row.lc_maturity}</td> */}
//                 <td className="py-2 px-4">
//                   {(() => {
//                     const date = new Date(row.lc_maturity);
//                     const day = String(date.getDate()).padStart(2, '0');
//                     const month = String(date.getMonth() + 1).padStart(
//                       2,
//                       '0'
//                     ); // Months are zero-based, so +1
//                     const year = date.getFullYear();
//                     return `${day}-${month}-${year}`;
//                   })()}
//                 </td>

//                 {/* <td className="py-2 px-4">
//                   {row.refinance ? 'Yes' : 'No'}
//                 </td> */}
//                 <td className="py-2 px-4">{row.tenor_required} months</td>

//                 <td className="py-2 px-4">
//                   <button
//                     className={`px-3 py-1 rounded-md md:w-28 w-20 ${
//                       row.status === 'offered'
//                         ? 'bg-green-500 text-white'
//                         : row.status === 'pending'
//                         ? 'bg-yellow-500 text-white'
//                         : row.status === 'cancel'
//                         ? 'bg-red-500 text-white'
//                         : 'bg-gray-500 text-white'
//                     }`}
//                   >
//                     {row.status === 'offered'
//                       ? 'Offered'
//                       : row.status === 'pending'
//                       ? 'Pending'
//                       : row.status === 'cancel'
//                       ? 'Cancelled'
//                       : 'Null'}
//                   </button>
//                 </td>

//                 {/* <td className="py-2 px-4 flex justify-center space-x-4 rounded-bl-lg">
//                   <button
//                     onClick={e => {
//                       e.stopPropagation();
//                       handleViewYourLoan(row.id);
//                     }}
//                     className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
//                     aria-label="View"
//                   >
//                     <img src={eye} alt="View" />
//                   </button>
//                   <button
//                     onClick={e => {
//                       e.stopPropagation();
//                       handleEdit(row.id);
//                     }}
//                     className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
//                     aria-label="Edit"
//                   >
//                     <img src={penEdit} alt="Edit" />
//                   </button>
//                 </td> */}
//                 {/* Your table data cells */}
//                 <td className="py-2 px-4 flex justify-center space-x-4 rounded-bl-lg lg:mt-0 mt-2">
//                   <button
//                     onClick={e => {
//                       e.stopPropagation();
//                       handleViewYourLoan(row);
//                     }}
//                     className="text-gray-600 hover:text-btnHover transition-colors text-2xl "
//                     aria-label="View"
//                   >
//                     <img src={eye} alt="View" />
//                   </button>
//                   <button
//                     onClick={e => {
//                       e.stopPropagation();
//                       handleEdit(row.id);
//                     }}
//                     className="text-gray-600 hover:text-btnHover transition-colors text-2xl"
//                     aria-label="Edit"
//                   >
//                     <img src={penEdit} alt="Edit" />
//                   </button>
//                 </td>
//               </tr>
//               {expandedRows[row.id] && <ChildTable loan_ID={row.id} />}
//             </React.Fragment>
//           ))
//         ) : (
//           <tr>
//             <td colSpan="9" className="text-center py-4">
//               <div className="flex items-center justify-center gap-2">
//                 <p>You don't have any UPAS/LC applicaton available. </p>
//                 <button
//                   onClick={handleNewApplication}
//                   className="underline hover:text-btnHover text-headerBtn"
//                 >
//                   {' '}
//                   Click for UPAS/LC new applicaton
//                 </button>
//               </div>
//             </td>
//           </tr>
//         )}
//       </tbody>
//     </table>
//   </div>
// </div>
